module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportInventory', 'inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Categroy"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inbound",
      "label": "INBD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noClaimed",
      "label": "Not Claimed"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProduct(scope.row.productNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.addProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "price", $$v)
      },
      expression: "addProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editProduct.price),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "price", $$v)
      },
      expression: "editProduct.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product FBM",
      "width": "80%",
      "visible": _vm.editFBMVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFBMVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "fbm",
    attrs: {
      "model": _vm.fbm,
      "label-width": "220px",
      "rules": _vm.fbmFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "productName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.productName),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "productName", $$v)
      },
      expression: "fbm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouseNo"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.fbm.warehouseNo),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "warehouseNo", $$v)
      },
      expression: "fbm.warehouseNo"
    }
  }, _vm._l((_vm.warehouseList), function(warehouse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": warehouse.warehouseNo,
        "label": warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Price",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.price),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "price", $$v)
      },
      expression: "fbm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.fbm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "quantity", $$v)
      },
      expression: "fbm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fbm.note),
      callback: function($$v) {
        _vm.$set(_vm.fbm, "note", $$v)
      },
      expression: "fbm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFBMVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addFBM($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Detail",
      "width": "80%",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {}
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inbound History",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking Number",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInboundList($event)
      }
    },
    model: {
      value: (_vm.filters.tracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tracking", $$v)
      },
      expression: "filters.tracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundUser", $$v)
      },
      expression: "filters.inboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Inbound Source",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getInboundList()
      }
    },
    model: {
      value: (_vm.filters.inboundType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inboundType", $$v)
      },
      expression: "filters.inboundType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "Offer",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Channel",
      "label": "Channel"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundType",
      "label": "Inbound Source"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inboundTotal
    },
    on: {
      "current-change": _vm.handleChangeInboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventoryDetail(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventoryDetail(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmDetailLoading),
      expression: "fbmDetailLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Outbound History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getOutboundList
    },
    model: {
      value: (_vm.filters.outboundUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "outboundUser", $$v)
      },
      expression: "filters.outboundUser"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.outboundList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 1) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Success")]) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Closed")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.outboundTotal
    },
    on: {
      "current-change": _vm.handleChangeOutboundList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Reported/Missed",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.reportedInbound,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Offer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.productName) + " " + _vm._s(scope.row.offerCreateDate ? "(" + scope.row.offerCreateDate + ")" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "Note"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.reportTotal
    },
    on: {
      "current-change": _vm.changeReportPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Not Claimed",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Tracking",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.notClaimedTracking),
      callback: function($$v) {
        _vm.$set(_vm.filters, "notClaimedTracking", $$v)
      },
      expression: "filters.notClaimedTracking"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getNotClaimed
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fiveListLoading),
      expression: "fiveListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.notClaimed,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "Tracking Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.notClaimedTotal
    },
    on: {
      "current-change": _vm.changeNotClaimedPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "FBM Operation Log",
      "name": "six"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Type",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getStockList
    },
    model: {
      value: (_vm.filters.stockFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "stockFilter", $$v)
      },
      expression: "filters.stockFilter"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Nurse Claimed",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Confirm Report",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Outbound",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Cancel Outbound",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Inbound",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Reverse",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Batch Reverse",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Warehouse Edit FBM",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Doctor Transfer",
      "value": 9
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sixListLoading),
      expression: "sixListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.stockList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "srcStock",
      "label": "Before operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "destStock",
      "label": "After operating FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bizType == 1) ? _c('p', [_vm._v("Nurse Claimed")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 2) ? _c('p', [_vm._v("Doctor Confirm Report")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 3) ? _c('p', [_vm._v("Doctor Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 4) ? _c('p', [_vm._v("Warehouse Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 5) ? _c('p', [_vm._v("Warehouse Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 6) ? _c('p', [_vm._v("Warehouse Edit FBM")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 7) ? _c('p', [_vm._v("Doctor Cancel Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 8) ? _c('p', [_vm._v("Warehouse Batch Reverse")]) : _vm._e(), _vm._v(" "), (scope.row.bizType == 9) ? _c('p', [_vm._v("Doctor Transfer")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operator",
      "prop": "userName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdTime",
      "label": "DateTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.stockTotal
    },
    on: {
      "current-change": _vm.changeStockPage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "FBM Detail",
      "width": "80%",
      "visible": _vm.fbmDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmDetailVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmDetailVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-378eb7f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/inventory.vue
// module id = 780
// module chunks = 1